module.exports = __webpack_public_path__ + "img/cellulose.69517c79.png";